import React from 'react';
import { Box, Button } from '@mui/material';

interface TabsProps {
    tabs: string[]; // <--- Now accepts ANY list of strings
    activeTab: string;
    onTabChange: (tab: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ 
    tabs, 
    activeTab, 
    onTabChange 
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {tabs.map((tab) => (
                <Button
                    key={tab}
                    variant="contained"
                    onClick={() => onTabChange(tab)}
                    sx={{
                        background: activeTab === tab
                            ? 'linear-gradient(45deg, black, #ed1b1b)'
                            : '#e0e0e0',
                        color: activeTab === tab ? '#fff' : '#000',
                        textTransform: 'none',
                        fontSize: '0.85rem',
                        padding: '6px 16px',
                        minWidth: 'auto',
                        fontWeight: activeTab === tab ? 'bold' : 'normal',
                        borderRadius: '20px',
                        boxShadow: activeTab === tab ? 2 : 0,
                        '&:hover': {
                            background: activeTab === tab
                                ? 'linear-gradient(45deg, black, #ed1b1b)'
                                : '#d5d5d5',
                        },
                    }}
                >
                    {tab}
                </Button>
            ))}
        </Box>
    );
};

export default Tabs;